const Home = () => import("../views/Home");
const MusicwowApp = () => import("../views/musicwowApp");
const Reservation = () => import("../views/Reservation");
const ReservationYes = () => import("../views/ReservationYes");
const Company = () => import("../views/Company");
const Dynamic = () => import("../views/Dynamic");
const DynamicDetails = () => import("../views/DynamicDetails");
const Contact = () => import("../views/Contact");
const Joinus = () => import("../views/Joinus");
const Teaching = () => import("../views/Teaching");
const Musicwow = () => import("../views/Musicwow");
const MusicwowDetails = () => import("../views/MusicwowDetails");
const SuperBook = () => import("../views/SuperBook");
const Course = () => import("../views/Course");
const SuperMor = () => import("../views/SuperMor");
const MusicMor = () => import("../views/MusicMor");
const Admin = () => import("../views/Admin");
const JoinPage = () => import("../views/JoinPage");
const preheat = () => import("../views/preheat");
const luckDraw = () => import("../views/luckDraw");
const newDraw = () => import("../views/activity/draw");
const activityPuzzle = () => import("../views/activity/puzzle/index.vue");
const exhibition2025 = () =>
  import("../views/activity/exhibition2025/index.vue");
const competitionNotice = () => import("../views/competitionNotice");
const captcha = () => import("../views/captcha");
const goodCourse = () => import("../views/goodCourse");
const appArticle = () => import("../views/appArticle");
const helpCourse = () => import("../views/helpCourse");
const appAboutus = () => import("../views/appAboutus");
const appHelpCenter = () => import("../views/appHelpCenter");
const initiation = () => import("../views/Initiation");
const musicSheet = () => import("../views/musicSheet");
const qrcodeRemind = () => import("../views/qrcodeRemind");
const miniappEntrance = () => import("../views/miniappEntrance");
export default [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "音乐窝官网",
      description: "多一种沟通方式；咨询电话：400~661~8883",
    },
  },
  {
    path: "/MusicwowApp",
    name: "MusicwowApp",
    component: MusicwowApp,
  },
  {
    path: "/Reservation",
    name: "Reservation",
    component: Reservation,
  },
  {
    path: "/ReservationYes",
    name: "ReservationYes",
    component: ReservationYes,
  },
  {
    path: "/Company",
    name: "Company",
    component: Company,
  },
  {
    path: "/Dynamic",
    name: "Dynamic",
    component: Dynamic,
  },
  {
    path: "/DynamicDetails",
    name: "DynamicDetails",
    component: DynamicDetails,
  },
  {
    path: "/Contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/Joinus",
    name: "Joinus",
    component: Joinus,
  },
  {
    path: "/Teaching",
    name: "Teaching",
    component: Teaching,
  },
  {
    path: "/Musicwow",
    name: "Musicwow",
    component: Musicwow,
  },
  {
    path: "/MusicwowDetails",
    name: "MusicwowDetails",
    component: MusicwowDetails,
  },
  {
    path: "/SuperBook",
    name: "SuperBook",
    component: SuperBook,
  },
  {
    path: "/Course",
    name: "Course",
    component: Course,
  },
  {
    path: "/SuperMor",
    name: "SuperMor",
    component: SuperMor,
  },
  {
    path: "/MusicMor",
    name: "MusicMor",
    component: MusicMor,
  },
  {
    path: "/Admin",
    name: "Admin",
    component: Admin,
  },
  {
    path: "/JoinPage",
    name: "JoinPage",
    component: JoinPage,
  },
  {
    path: "/preheat",
    name: "preheat",
    component: preheat,
    meta: {
      title: "“职协杯”2020全国鼓手大赛",
    },
  },
  {
    path: "/luckDraw",
    name: "luckDraw",
    component: luckDraw,
  },
  {
    path: "/activity/draw", // 新抽奖页面
    name: "newDraw",
    component: newDraw,
  },
  {
    path: "/activity/exhibition2025", //2025乐展品牌页面
    name: "exhibition2025",
    component: exhibition2025,
  },
  {
    path: "/activity/puzzle",
    name: "activityPuzzle",
    component: activityPuzzle,
  },
  {
    path: "/competitionNotice",
    name: "competitionNotice",
    component: competitionNotice,
    meta: {
      title: "大赛刷票公告",
    },
  },
  {
    path: "/captcha",
    name: "captcha",
    component: captcha,
    meta: {
      title: "滑动验证",
    },
  },
  {
    path: "/goodCourse",
    name: "goodCourse",
    component: goodCourse,
    meta: {
      title: "精品课",
    },
  },
  {
    path: "/appArticle",
    name: "appArticle",
    component: appArticle,
    meta: {
      title: "APP文章",
    },
  },
  {
    path: "/helpCourse",
    name: "helpCourse",
    component: helpCourse,
    meta: {
      title: "助力学好课",
    },
  },
  {
    path: "/appAboutus",
    name: "appAboutus",
    component: appAboutus,
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/appHelpCenter",
    name: "appHelpCenter",
    component: appHelpCenter,
    meta: {
      title: "帮助中心",
    },
  },
  {
    path: "/initiation",
    name: "initiation",
    component: initiation,
    meta: {
      title: "【音乐窝】音乐素养AI课",
      description: "让孩子在趣味益知的奇妙旅程中快乐成长、玩音乐从这里开始！",
      timeLine: "音乐素养AI课，玩音乐从这里开始！",
    },
  },
  {
    path: "/music_sheet",
    name: "musicSheet",
    component: musicSheet,
    meta: {
      title: "曲谱详情",
    },
  },
  {
    path: "/qrcode_remind",
    name: "qrcodeRemind",
    component: qrcodeRemind,
    meta: {
      title: "扫码提示",
    },
  },
  {
    path: "/miniapp_entrance",
    name: "miniappEntrance",
    component: miniappEntrance,
    meta: {
      title: "打开小程序",
    },
  },
];
